import qs from 'query-string';

import axios from './axios';
import { handleUnauthorizedError } from './heartBeat';

export const fetchFn = (START, SUCCESS, ERROR) => {
    return (url, queryFields, config) => {
        return async dispatch => {
            dispatch({ type: START });
            /* stringify convert from object { prop1: 'a', prop2: 'b'}
             * to query string: prop1=a&prop2=b
             */
            const queryString = qs.stringify(queryFields);
            try {
                const { data } = await axios.get(queryString ? `${url}?${queryString}` : url, config);
                dispatch({
                    type: SUCCESS,
                    payload: data
                });
            } catch (err) {
                handleUnauthorizedError(err, dispatch);
                dispatch({
                    type: ERROR,
                    payload: err,
                    error: true
                });
            }
        };
    };
};

export const postFn = (START, SUCCESS, ERROR) => {
    return (url, body, config, objectId) => {
        return async dispatch => {
            dispatch({
                type: START,
                ...(objectId && { objectId })
            });
            try {
                const { data } = await axios.post(url, body, config);
                dispatch({
                    type: SUCCESS,
                    payload: data
                });
            } catch (err) {
                handleUnauthorizedError(err, dispatch);
                dispatch({
                    type: ERROR,
                    payload: err,
                    error: true
                });
            }
        };
    };
};

export const putFn = (START, SUCCESS, ERROR) => {
    return (url, body, config) => {
        return async dispatch => {
            dispatch({ type: START });
            try {
                const { data } = await axios.put(url, body, config);
                dispatch({
                    type: SUCCESS,
                    payload: data
                });
            } catch (err) {
                handleUnauthorizedError(err, dispatch);
                dispatch({
                    type: ERROR,
                    payload: err,
                    error: true
                });
            }
        };
    };
};

export const deleteFn = (START, SUCCESS, ERROR) => {
    return (url, config) => {
        return async dispatch => {
            dispatch({ type: START });
            try {
                const { data } = await axios.delete(url, config);
                dispatch({
                    type: SUCCESS,
                    payload: data
                });
            } catch (err) {
                handleUnauthorizedError(err, dispatch);
                dispatch({
                    type: ERROR,
                    payload: err,
                    error: true
                });
            }
        };
    };
};
